// @ts-strict-ignore
import { removeWhitespaceAndSpecialChars } from '../../helpers/commons'
import React from 'react'
import { MoneyVoiceTopPickCard } from './card'

const TOP_THREE_SCORES = [4.8, 4.5, 4]

const getReview = (id, reviews) => {
  return reviews.find((r) => r?.fields?.id?.id === id)
}

const MoneyVoiceTopPicks = (props) => {
  const { data, name, variant, sys, title, subTitle, product, reviews, brand, path, rowCount } =
    props

  try {
    return (
      <div className='money-voice-top-picks' id={removeWhitespaceAndSpecialChars(name)}>
        {title && <h2 className='money-voice-top-picks__heading'>{title}</h2>}
        {subTitle && <p className='money-voice-top-picks__description'>{subTitle}</p>}
        {data.map((ele, i) => {
          if (i <= rowCount - 1) {
            const review = getReview(ele._id, reviews.reviews)
            return (
              <div
                className='money-voice-top-picks__container money-voice-top-picks__container--single'
                key={ele._id}
              >
                {MoneyVoiceTopPickCard(
                  ele,
                  variant,
                  name,
                  sys,
                  product,
                  review,
                  reviews.includes,
                  brand,
                  path,
                  TOP_THREE_SCORES[i],
                )}
              </div>
            )
          }
        })}
      </div>
    )
  } catch (e) {
    return (
      // eslint-disable-next-line no-console
      console.log(JSON.stringify(`MONEY VOICE TOP PICKS MISSING: ${e}`))
    )
  }
}

export default MoneyVoiceTopPicks
